import React from 'react';

const DragHandle = React.forwardRef(function DragHandle({ label, ...props }, ref) {
  return (
    <button type="button" ref={ref} className="drag-handle" aria-label={label} {...props}>
      <svg width="12" height="16" viewBox="0 0 12 16" fill="currentColor" aria-hidden="true">
        <circle cx="3" cy="3" r="1.4" />
        <circle cx="9" cy="3" r="1.4" />
        <circle cx="3" cy="8" r="1.4" />
        <circle cx="9" cy="8" r="1.4" />
        <circle cx="3" cy="13" r="1.4" />
        <circle cx="9" cy="13" r="1.4" />
      </svg>
    </button>
  );
});

export default DragHandle;